export default {
    // Home page
    home: {
        title: 'Timer.today • 最高のオンラインタイマー、ストップウォッチ、世界時計ツール',
        description: '⏰無料のオンラインタイミングツール：カウントダウンタイマー、高精度ストップウォッチ、世界時計。生産性、料理、勉強、スポーツトレーニング、タイムゾーン管理に最適。広告なし。',
        keywords: ['オンラインタイマー', 'カウントダウンタイマー', 'オンラインストップウォッチ', '世界時計', '生産性タイマー', 'ポモドーロタイマー', '料理タイマー', '無料タイマーツール', 'ブラウザタイマー', '時間管理'],
        ogTitle: 'プロフェッショナルオンラインタイマーツール - timer.today',
        ogDescription: 'カウントダウンタイマー、ストップウォッチ、世界時計機能を提供するプロフェッショナルなオンラインタイミングツールプラットフォーム',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Timer.Today",
            "description": "無料のオンラインタイミングツール：カウントダウンタイマー、高精度ストップウォッチ、世界時計。生産性、料理、勉強、スポーツトレーニング、タイムゾーン管理に最適。広告なし。",
            "url": "https://timer.today",
            "applicationCategory": "Productivity",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "JPY"
            },
            "featureList": [
                "オンラインタイマー",
                "サウンドアラート",
                "複数のタイマープリセット",
                "ストップウォッチ",
                "世界時計"
            ],
            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "reviewCount": "503"
            }
        }
    },

    // Timer page
    timer: {
        title: 'オンラインタイマー • サウンドアラート付き無料カウントダウンツール',
        description: '⏰カスタム設定付きオンラインカウントダウンタイマー。ポモドーロ、勉強、作業休憩用の10分/15分クイックスタート。無料+サウンドアラート🔔！',
        keywords: [
            '10分タイマー', '15分タイマー', '30分タイマー',
            'ポモドーロタイマー', '勉強タイマー', '作業休憩タイマー',
            'サウンドアラート付きタイマー', 'オンラインカウントダウンツール',
            '生産性タイマー', '時間管理ツール'
        ],
        ogTitle: '無料オンラインタイマー - 勉強と作業休憩に最適',
        ogDescription: '⏰サウンドアラート付きカスタムカウントダウンタイマーを設定。ポモドーロテクニック、勉強セッション、生産性に最適。登録不要！',
        ogUrl: 'https://timer.today/timer',
        twitterTitle: '無料オンラインタイマー - 生産性を向上',
        twitterDescription: '⏰サウンドアラート付きカスタムカウントダウンタイマー。ポモドーロ、勉強休憩、時間管理に最適。今すぐ開始！',
        twitterCard: 'summary_large_image',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "オンラインタイマー - 無料カウントダウンツール",
            "description": "カスタム時間設定、サウンドアラート、プリセットオプション付き無料オンラインカウントダウンタイマー。生産性と時間管理に最適。",
            "url": "https://timer.today/timer",
            "applicationCategory": "Productivity",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "JPY",
                "availability": "https://schema.org/InStock"
            },
            "isAccessibleForFree": true,
            "publisher": {
                "@type": "Organization",
                "name": "Timer.Today",
                "url": "https://timer.today"
            },
            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "ratingCount": "70",
                "bestRating": "5"
            }
        }
    },

    // Stopwatch page
    stopwatch: {
        title: 'オンラインストップウォッチ • ミリ秒精度の高精度タイマー',
        description: '⏱️ミリ秒精度のプロフェッショナルオンラインストップウォッチ。スポーツトレーニング、フィットネスワークアウト、料理、勉強のタイミングに最適。無料+正確！🎯',
        keywords: [
            'オンラインストップウォッチ', '精密ストップウォッチ', 'ミリ秒タイマー',
            'デジタルストップウォッチ', '無料ストップウォッチ', '正確なストップウォッチ',
            'ミリ秒付きストップウォッチ', '高精度タイマー',
            'プロフェッショナルストップウォッチ', 'ラップタイマー', 'スプリットタイマー',
            'スポーツタイマー', 'トレーニングストップウォッチ', 'フィットネスタイマー',
            '料理ストップウォッチ', 'ワークアウトタイマー', 'ランニングストップウォッチ'
        ],
        ogTitle: '無料オンラインストップウォッチ - ミリ秒精度タイマー',
        ogDescription: '⏱️スポーツ、フィットネス、料理、トレーニング用の正確なタイミングのプロフェッショナルストップウォッチ。ミリ秒精度、ラップタイム、スプリットタイミング。今すぐ開始！',
        ogUrl: 'https://timer.today/stopwatch',
        twitterTitle: '精密オンラインストップウォッチ - スポーツとトレーニングに最適',
        twitterDescription: '⏱️ミリ秒精度の高精度ストップウォッチ。アスリート、コーチ、正確なタイミングが必要な人に最適。',
        twitterCard: 'summary_large_image',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "オンラインストップウォッチ - 高精度タイマー",
            "description": "ミリ秒精度のプロフェッショナルオンラインストップウォッチ。スポーツトレーニング、フィットネスワークアウト、料理タイミング、正確な時間測定に最適。",
            "url": "https://timer.today/stopwatch",
            "applicationCategory": "Productivity",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "JPY",
                "availability": "https://schema.org/InStock"
            },
            "isAccessibleForFree": true,
            "publisher": {
                "@type": "Organization",
                "name": "Timer.Today",
                "url": "https://timer.today"
            },
            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.7",
                "ratingCount": "89",
                "bestRating": "5"
            }
        }
    },

    // World Clock page
    worldclock: {
        title: '世界時計 • ライブグローバルタイムゾーンと現在時刻',
        description: '🌍200以上の都市の現在時刻を表示するライブ世界時計。リアルタイムタイムゾーン、会議プランナー、タイムゾーンコンバーター。無料で正確！⏰',
        keywords: [
            '世界時計', 'グローバルタイムゾーン', '今の時間', 'タイムゾーンコンバーター',
            'インドの時間', 'ニューヨーク時間', 'グローバル会議時間',
            'ライブ世界時計', 'リアルタイム世界時計', '現在の世界時間',
            'アメリカタイムゾーン', 'ヨーロッパタイムゾーン', 'アジアタイムゾーン',
            'ニューヨーク時間', 'ロンドン時間', '東京時間', 'シドニー時間',
            '世界の時刻', '国際時間比較'
        ],
        ogTitle: 'ライブ世界時計 - 200以上のグローバル都市の現在時刻',
        ogDescription: '🌍世界中の現在時刻を瞬時に確認！国際ビジネス会議、旅行計画、グローバル接続に最適。無料ライブ更新！',
        ogUrl: 'https://timer.today/worldclock',
        twitterTitle: '世界時計 - グローバル会議時間を二度と逃さない',
        twitterDescription: '🌍200以上の都市のライブ世界時計。国際ビジネス、旅行、グローバル調整に最適。リアルタイム更新！',
        twitterCard: 'summary_large_image',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "世界時計 - ライブグローバルタイムゾーン",
            "description": "世界200以上の主要都市の現在時刻を表示するリアルタイム世界時計。国際ビジネス、旅行計画、グローバル調整に最適。",
            "url": "https://timer.today/worldclock",
            "applicationCategory": "Productivity",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "JPY",
                "availability": "https://schema.org/InStock"
            },
            "isAccessibleForFree": true,
            "publisher": {
                "@type": "Organization",
                "name": "Timer.Today",
                "url": "https://timer.today"
            }
        }
    },

    // Terms page
    terms: {
        title: '利用規約 - timer.today',
        description: 'timer.todayオンラインタイミングツールプラットフォームの利用規約と使用契約。サービスルール、ユーザーの権利と責任について学びます。',
        keywords: ['利用規約', 'ユーザー契約', 'タイマーツール規約'],
        ogTitle: '利用規約 - timer.today',
        ogDescription: 'timer.todayオンラインタイミングツールプラットフォームの利用規約と使用契約',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "利用規約",
            "description": "timer.todayオンラインタイミングツールプラットフォームの利用規約と使用契約"
        }
    },

    // Dynamic timer pages
    timerMinutes: (minutesNum: number) => {
        const useCases = {
            1: '目の休憩、クイック瞑想、お茶の淹れ方',
            3: '卵の茹で方、コーヒーの淹れ方、短い休憩',
            5: '瞑想練習、半熟卵、クイックワークアウト',
            10: '学習休憩、電話、読書セッション',
            15: 'ポモドーロ作業セッション、中程度のワークアウト、深い学習',
            20: '集中作業期間、フィットネスエクササイズ、スキルトレーニング',
            25: '標準ポモドーロテクニック、ディープワーク、プロフェッショナル学習',
            30: '長い集中セッション、ワークアウトルーチン、深い学習',
            45: 'ディープワーク期間、スピーチ練習、プロフェッショナルトレーニング',
            60: '作業時間ブロック、コース学習、延長ワークアウト'
        }[minutesNum] || '生産性と時間管理';

        return {
            title: `${minutesNum}分タイマー - 生産性のためのオンラインカウントダウンタイマー`,
            description: `${useCases}に最適な無料${minutesNum}分カウントダウンタイマー。サウンドアラート、全画面モード、カスタム設定機能付き。今すぐ${minutesNum}分タイマーを開始！`,
            keywords: [`${minutesNum}分タイマー`, `${minutesNum}分タイマー`, 'カウントダウンタイマー', '生産性タイマー', useCases.split('、')[0], useCases.split('、')[1]],
            ogTitle: `${minutesNum}分タイマー - timer.today`,
            ogDescription: `${useCases}に最適なサウンドアラートとデスクトップ通知付き${minutesNum}分カウントダウンタイマー`,
            jsonLd: {
                "@context": "https://schema.org",
                "@type": "WebApplication",
                "name": `${minutesNum}分タイマー`,
                "description": `${useCases}に最適なサウンドアラートとデスクトップ通知付き${minutesNum}分カウントダウンタイマー`,
                "applicationCategory": "Productivity"
            }
        };
    },

    // Timestamp converter page
    timestamp: {
        title: 'Unixタイムスタンプコンバーター - エポックタイムから日付へ & コードスニペット | timer.today',
        description: '無料オンラインUnixタイムスタンプコンバーター。エポックタイムを日付に変換、またはその逆。Python、Java、MySQL、JavaScript、PHPのタイムスタンプチートシート付き。',
        keywords: [
            'タイムスタンプコンバーター',
            'unixタイムスタンプ',
            'エポックタイムコンバーター',
            'タイムスタンプから日付へ',
            '日付からタイムスタンプへ',
            'unix時間コンバーター',
            'pythonタイムスタンプ',
            'javaタイムスタンプ',
            'mysqlタイムスタンプ',
            'javascriptタイムスタンプ',
            'phpタイムスタンプ'
        ],
        ogTitle: 'Unixタイムスタンプコンバーター & エポックタイムツール',
        ogDescription: 'Python、Java、MySQL、JavaScript、PHPのコード例付きでエポックタイムを日付に変換。無料オンラインタイムスタンプコンバーター。',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Unixタイムスタンプコンバーター",
            "description": "Python、Java、MySQL、JavaScript、PHPのコードスニペット付き無料オンラインUnixタイムスタンプコンバーター",
            "url": "https://timer.today/timestamp",
            "applicationCategory": "DeveloperApplication",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "JPY"
            }
        }
    },

    // Discord Timestamp Generator
    discordTimestamp: {
        title: 'Discordタイムスタンプジェネレーター - <t:format>コードを作成 | timer.today',
        description: '🎮自動タイムゾーン変換付きDiscordタイムスタンプを生成。イベント、カウントダウン、お知らせ用の<t:timestamp:format>コードを作成。すべてのDiscordチャンネルで動作！',
        keywords: [
            'discordタイムスタンプ',
            'discordタイムスタンプジェネレーター',
            'discord時刻フォーマット',
            'discordタイムスタンプコード',
            'discord <t> フォーマット',
            'discordタイムスタンプコンバーター'
        ],
        ogTitle: 'Discordタイムスタンプジェネレーター - 自動タイムゾーン変換',
        ogDescription: 'すべてのユーザーの現地タイムゾーンに自動調整されるDiscordタイムスタンプコードを生成。イベント、レイド、コミュニティスケジューリングに最適。',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Discordタイムスタンプジェネレーター",
            "description": "イベントとお知らせ用の自動タイムゾーン変換付きDiscordタイムスタンプコードを生成",
            "url": "https://timer.today/discord-timestamp-generator",
            "applicationCategory": "UtilitiesApplication"
        }
    },

    // Dynamic city pages
    city: ({ cityName, countryName, timezone }: { cityName: string, countryName: string, timezone: string }) => ({
        title: `${cityName}の現在時刻 - ライブ${cityName}時刻とタイムゾーン`,
        description: `🌍${countryName}の${cityName}は今何時？現在の現地時刻、タイムゾーン（${timezone}）、UTCオフセット、日付を確認。会議のスケジュールと国際電話に最適。無料ライブ更新！`,
        keywords: [
            `${cityName}の時刻`,
            `${cityName}時間`,
            `現在時刻${cityName}`,
            `${cityName}タイムゾーン`,
            `${cityName}時計`,
            `${cityName}は今何時`,
            `${cityName}現地時刻`,
            `タイムゾーン${cityName}`,
            `${cityName} ${countryName}時間`,
            '世界時計',
            '国際時間'
        ],
        ogTitle: `${countryName}の${cityName}の現在時刻 - ライブ時計`,
        ogDescription: `${cityName}の現在時刻を確認（${timezone}）。タイムゾーン情報と日付付きのリアルタイム更新。国際スケジューリングに最適。`,
        ogUrl: `https://timer.today/worldclock/time-in/${cityName.toLowerCase().replace(/\s+/g, '-')}`,
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": `${cityName}の現在時刻`,
            "description": `タイムゾーン${timezone}の${countryName}${cityName}の現在の現地時刻`,
            "url": `https://timer.today/worldclock/time-in/${cityName.toLowerCase().replace(/\s+/g, '-')}`,
            "isPartOf": {
                "@type": "WebSite",
                "name": "Timer.Today",
                "url": "https://timer.today"
            }
        }
    }),

    // Dynamic country pages
    country: ({ countryName, citiesCount }: { countryName: string, citiesCount: number }) => ({
        title: `${countryName}の時刻 - 現在の現地時刻とタイムゾーン`,
        description: `🌍${citiesCount}以上の都市の${countryName}の現在時刻を確認。リアルタイムタイムゾーン更新、UTCオフセット、現地時刻。ビジネス会議と国際調整に最適。`,
        keywords: [
            `${countryName}の時刻`,
            `${countryName}時間`,
            `${countryName}タイムゾーン`,
            `現在時刻${countryName}`,
            `${countryName}時計`,
            `${countryName}は今何時`,
            `${countryName}現地時刻`,
            `${countryName}都市時刻`,
            '世界時計',
            '国際時間'
        ],
        ogTitle: `${countryName}の現在時刻 - ${citiesCount}以上の都市`,
        ogDescription: `すべての主要都市の${countryName}の現在時刻を表示。ライブ更新付きのリアルタイムタイムゾーン情報。`,
        ogUrl: `https://timer.today/worldclock/country/${countryName.toLowerCase().replace(/\s+/g, '-')}`,
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": `${countryName}の時刻`,
            "description": `${citiesCount}以上の都市をカバーする${countryName}の現在の現地時刻`,
            "url": `https://timer.today/worldclock/country/${countryName.toLowerCase().replace(/\s+/g, '-')}`
        }
    })
};
